'use strict';
import Analytics from "./analytics";

class ComboBox {

    constructor() {
        this.previousIconEl = undefined;

        const KEYCODE = {
            UP: 38,
            DOWN: 40,
            ENTER: 13
        };

        this.comboBox = document.querySelector('.combobox');
        this.searchContainer = document.querySelector('.header__quicksearch');
        this.comboBoxList = document.querySelector('#combobox__listbox');
        this.comboBoxContainer = document.querySelector('.combobox__container');
        this.popularSearchTerms = document.querySelector('#popular-searches');
        this.showButtonEl = document.querySelector('.combobox__button');
        this.showButtonElMobile = document.querySelector('.combobox__button--mobile');
        this.buttonCloseEl = document.querySelector('.combobox__close');
        this.searchFieldEl = document.querySelector('.combobox__searchField');
        this.quickSearchForm = document.querySelector('#header-quick-search');
        this.showButtonElTest = document.querySelector('.combobox__button span');

        if (this.showButtonEl == null) {
            return;
        }

        this.searchFieldLabelEl = this.showButtonEl.querySelector('span');
        this.searchForm = document.querySelector('.header__quicksearch');
        this.showQuickSearch = this.showQuickSearch.bind(this);
        this.previousActiveElement = undefined;

        this.addEventListeners();

        const keyboardHandler = (e) => {
            let list = this.comboBoxList;
            let first = list.firstElementChild; // targets the first <li>  
            let maininput = this.searchFieldEl;  // targets the input, which triggers the functions populating the list

            if (maininput === document.activeElement) {
                switch (e.keyCode) {
                    case KEYCODE.UP: // if the UP key is pressed
                        e.preventDefault();
                        if (document.activeElement === (maininput || first)) {
                            break;
                        } // stop the script if the focus is on the input or first element
                        else {
                            if (document.activeElement.previousElementSibling) {
                                maininput.value = document.activeElement.previousElementSibling.textContent;
                                document.activeElement.previousElementSibling.focus();

                            } else {
                                maininput.value = list.lastElementChild.textContent;
                                list.lastElementChild.focus();
                            }
                        } // select the element before the current, and focus it
                        break;
                    case KEYCODE.DOWN: // if the DOWN key is pressed
                        e.preventDefault();
                        if (document.activeElement === maininput) {
                            first.focus();
                            maininput.value = first.textContent;
                        } // if the currently focused element is the main input --> focus the first <li>
                        else {
                            if (document.activeElement.nextElementSibling) {
                                maininput.value = document.activeElement.nextElementSibling.textContent;
                                document.activeElement.nextElementSibling.focus();
                            } else {
                                maininput.value = list.firstElementChild.textContent;
                                list.firstElementChild.focus();
                            }
                        } // target the currently focused element -> <a>, go up a node -> <li>, select the next node, go down a node and focus it
                        break;
                    case KEYCODE.ENTER:
                        if (this.comboBoxList.contains(document.activeElement)) {
                            list.classList.add('combobox__search-hints-list--hidden');
                            this.searchForm.submit();
                        }
                        break;
                    default:
                        maininput.focus();
                        list.classList.add('combobox__search-hints-list--hidden');
                }
            }
        };

        const suggest = (query) => {

            const currentValue = this.searchFieldEl.value;
            if (query != currentValue)
                return;

            query = query.trim();
            if (!query)
                return;

            let results = [];

            fetch(`/find_v2/_autocomplete?prefix=${query}&size=10`)
                .then((response) => {
                    return response.json();
                })
                .then((json) => {
                    results = json.hits.map((hit) => {
                        return hit.query.replace(/\*/g, "").replace(/ and /g, " ");
                    });
                    return results;
                }).then((hits) => {
                    if (this.searchFieldEl.value === query)
                        render(hits);
                });
        };

        const render = (hits) => {
            this.comboBoxList.innerHTML = '';

            this.comboBox.setAttribute('aria-expanded', true);
            this.comboBoxList.classList.remove('combobox__search-hints-list--hidden');

            if (hits.length <= 0) {
                this.comboBoxList.classList.add('combobox__search-hints-list--hidden');
                this.comboBox.setAttribute('aria-expanded', false);
            }

            hits.forEach(hit => {
                const li = document.createElement('li');
                li.setAttribute('tabindex', '-1');
                li.classList.add('combobox__search-hints-item');
                const link = document.createElement('a');
                link.textContent = hit;
                link.setAttribute('href', `${this.quickSearchForm.action}?q=${hit}`);
                li.appendChild(link);
                this.comboBoxList.appendChild(li);

            });
        };

        let timeoutId;
        this.searchFieldEl.addEventListener('input', (e) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                suggest(e.target.value);
            }, 500);
        });

        window.addEventListener('keydown', (e) => keyboardHandler(e));
    }

    addEventListeners() {
        this.showButtonEl.addEventListener('click', (e) => {
            this.searchFieldEl.classList.contains('combobox__searchField--visible') ? this.hideQuickSearch(e) : this.showQuickSearch(e);
        });

        this.showButtonElMobile.addEventListener('click', (e) => {
            this.searchFieldEl.classList.contains('combobox__searchField--visible') ? this.hideQuickSearch(e) : this.showQuickSearch(e);
        });

        this.buttonCloseEl.addEventListener('click', (e) => {
            this.hideQuickSearch(e);
        });
        
        const container = document.querySelector('.combobox__container');
        container.addEventListener('click', (e) => {
            e.stopPropagation();
            if(!e.target.matches('.combobox__search-hints-item a')) {
                return;
            }
            const target = e.target;
            const data = {
                'event': 'searchGlobal',
                'searchTerm': target.textContent,
                'isAuthenticated': Analytics.getAuthenticated(),
                'selectedBranch': Analytics.getBranchName()
            };
            window.dataLayer.push(data);
        });
        this.quickSearchForm.addEventListener('submit', (e) => {
            const inputVal = this.searchFieldEl.value;
            if (!inputVal) {
                return
            }
            
            const data = {
                'event': 'searchGlobal',
                'searchTerm': inputVal,
                'isAuthenticated': Analytics.getAuthenticated(),
                'selectedBranch': Analytics.getBranchName()
            };
            window.dataLayer.push(data);    
        });
            
            
            
        this.handlePopularSearchTermsEvents();
    }

    handlePopularSearchTermsEvents = () => {
        if (!this.popularSearchTerms)
            return;

        const self = this;

        this.searchFieldEl.addEventListener('focus', (e) => {
            if (e.currentTarget.value.length === 0) {
                self.popularSearchTerms.classList.remove('combobox__search-hints-list--hidden');
            }
        });

        this.searchFieldEl.addEventListener('blur', (e) => {
            setTimeout(() => {
                self.popularSearchTerms.classList.add('combobox__search-hints-list--hidden');
            }, 150);
        });

        this.searchFieldEl.addEventListener('input', (e) => {
            if (e.currentTarget.value.length === 0) {
                self.popularSearchTerms.classList.remove('combobox__search-hints-list--hidden');
            } else {
                self.popularSearchTerms.classList.add('combobox__search-hints-list--hidden');
            }
        });
    }

    showQuickSearch(e) {
        e.preventDefault();
        this.previousActiveElement = e.target;
        this.searchFieldEl.classList.add('combobox__searchField--visible');
        this.comboBoxContainer.classList.add('combobox__container--visible');
        this.searchContainer.classList.add('header__quicksearch--visible');
        this.searchContainer.setAttribute('aria-hidden', "false");
        this.showButtonEl.setAttribute('aria-label', 'avbryt');
        this.searchFieldEl.focus();
    }

    hideQuickSearch(e) {
        e.preventDefault();
        this.comboBoxContainer.classList.remove('combobox__container--visible');
        this.comboBoxList.classList.add('combobox__search-hints-list--hidden');
        this.searchContainer.classList.remove('header__quicksearch--visible');
        this.searchFieldEl.classList.remove('combobox__searchField--visible');
        this.searchContainer.setAttribute('aria-hidden', "true");
        this.showButtonEl.setAttribute('aria-label', 'Sök på webbplatsen');
        this.previousActiveElement.focus();
    }

}

document.addEventListener("DOMContentLoaded", () => new ComboBox());
